/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useEffect, useRef } from "react";
import { Animated, StyleProp, ViewStyle } from "react-native";

interface FadeInOutViewProps {
  duration?: number;
  visible?: boolean;
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
}

export default function FadeInOutView({
  duration = 300,
  visible = true,
  style,
  children,
  ...rest
}: FadeInOutViewProps) {
  const animation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(animation, {
      toValue: visible ? 1 : 0,
      duration,
      useNativeDriver: true,
    }).start();
  }, [visible, animation, duration]);

  const containerStyle = {
    opacity: animation.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    }),
  };

  return (
    <Animated.View style={[containerStyle, style]} {...rest}>
      {children}
    </Animated.View>
  );
}
